import { ExternalLink } from "~/components/site/external-link";
import { formatUrl } from "~/lib/format-url";

type Company = Readonly<{
  name: string;
  icon: string;
  url: string;
}>;

type Props = Readonly<{
  companies: Company[];
}>;

export function Directory({ companies }: Props): JSX.Element {
  return (
    <div className="flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 max-w-none mt-8">
      {companies.map((company: Company) => (
        <ExternalLink
          key={company.name}
          className="border border-primary hover:border-gray-400 hover:dark:border-gray-600 bg-secondary round flex flex-col no-underline"
          href={company.url}
        >
          <div className="flex flex-col flex-grow gap-4 p-6">
            <div className="flex flex-col gap-4 flex-grow">
              <div className="flex items-center gap-x-3">
                <img
                  className="h-12 w-12 my-0 rounded-full border border-primary"
                  src={company.icon}
                  alt={company.name}
                />
                <div className="flex flex-col gap-0">
                  <h4 className="h5 m-0">{company.name}</h4>
                  <span className="text-sm prose dark:prose-invert">
                    {formatUrl(company.url)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ExternalLink>
      ))}
    </div>
  );
}
